import { AuthErrorCode, LoginErrorCode } from './errorCodes';

export const LOGIN_ERROR_MESSAGES: Record<LoginErrorCode, string> = {
  [LoginErrorCode.EMPTY_USERNAME]: 'Please fill in all required fields.',
  [LoginErrorCode.EMPTY_PASSWORD]: 'Please fill in all required fields.',
  [LoginErrorCode.INVALID_USERNAME]: 'Please enter a valid email address.',
  [LoginErrorCode.INVALID_EMAIL]: 'Please enter a valid email address.',
  [LoginErrorCode.INCORRECT_PASSWORD]: 'The password is incorrect. Please try again.',
  [LoginErrorCode.AUTHENTICATION_FAILED]: "We couldn't sign you in. Please check your details and try again.",
};

export const AUTH_ERROR_MESSAGES: Partial<Record<AuthErrorCode, string>> = {
  // Common - Missing Fields
  [AuthErrorCode.MISSING_PHONE]: 'Please enter your phone number.',
  [AuthErrorCode.MISSING_OTP]: 'Please enter your verification code.',
  [AuthErrorCode.MISSING_NAME]: 'Please enter your name.',
  [AuthErrorCode.MISSING_EMAIL]: 'Please enter your email address.',

  // Common - Format Errors
  [AuthErrorCode.INVALID_PHONE_FORMAT]: 'Please enter a valid phone number.',
  [AuthErrorCode.INVALID_EMAIL_FORMAT]: 'Please enter a valid email address.',
  [AuthErrorCode.INVALID_OTP]: 'The verification code is incorrect. Please check and try again.',

  // Server Errors
  [AuthErrorCode.SERVER_ERROR]: "Something went wrong on our end. We're looking into it—please try again shortly.",
  [AuthErrorCode.SMS_DELIVERY_FAILED]: "We couldn't send the verification code. Please wait a moment and try again.",

  // OTP
  [AuthErrorCode.OTP_EXPIRED]: 'The verification code has expired. Please request a new one.',
  [AuthErrorCode.OTP_NOT_FOUND]: 'Your verification has expired. Please start the verification again.',
  [AuthErrorCode.OTP_NOT_VERIFIED]: "Verification isn't complete yet. Please complete the verification first.",
  [AuthErrorCode.MAX_ATTEMPTS_EXCEEDED]:
    "You've reached the maximum number of attempts. Please wait a moment and try again.",
  [AuthErrorCode.RATE_LIMIT_EXCEEDED]:
    "You've made too many requests in a short time. Please wait a moment and try again.",

  // Email Verification
  [AuthErrorCode.SESSION_NOT_FOUND]: 'Your verification has expired. Please start the verification again.',
  [AuthErrorCode.SESSION_LOCKED]:
    'Your session has been locked for security reasons. Please start the verification again.',

  // Registration
  [AuthErrorCode.USER_ALREADY_EXISTS]: 'This email is already registered. Please use a different email address.',
  [AuthErrorCode.CUSTOMER_CREATION_FAILED]: 'Something went wrong while creating your account. Please try again later.',

  // Google OAuth
  [AuthErrorCode.USER_NOT_FOUND]: 'No linked account was found. Please complete registration to continue.',
};
